var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dialogVisible
    ? _c(
        "el-dialog",
        {
          staticClass: "dialog",
          attrs: {
            title: "详情",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            width: "60%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "auto-table-flex" },
            [
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.tableData,
                    height: "300",
                    border: true,
                    "tooltip-effect": "dark",
                    "header-cell-style": {
                      color: "#333333",
                      background: "#EFF6FF",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "sku_code",
                      width: "100px",
                      align: "center",
                      label: "货号",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "supplier_name",
                      align: "center",
                      label: "供应商名称",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "create_time",
                      align: "center",
                      label: "添加时间",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "owner_name",
                      align: "center",
                      label: "添加人",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "quantity", align: "center", label: "件数" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "deduction_amt",
                      align: "center",
                      label: "扣款金额",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "video_list",
                      align: "center",
                      label: "视频证据",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "pointer font-weight",
                                  staticStyle: { color: "#1389ae" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onHandleShow(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("查看证据")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2501533168
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "qc_type_line",
                      align: "center",
                      label: "问题原因",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remarks",
                      align: "center",
                      label: "缺少斤数*毛单价",
                      "min-width": "150",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(scope.row.weight) +
                                  "*" +
                                  _vm._s(scope.row.weight_price) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2453192808
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "remarks",
                      align: "center",
                      label: "备注",
                      width: "300",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "fy" },
            [
              _c("el-pagination", {
                attrs: {
                  type: "primary",
                  background: "",
                  "current-page": _vm.from.pageSize,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.from.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _c("c-preview-file", {
            attrs: {
              fileList: _vm.fileList,
              fileIndex: _vm.previewIndex,
              fileType: _vm.fileType,
            },
            model: {
              value: _vm.dialogVisible1,
              callback: function ($$v) {
                _vm.dialogVisible1 = $$v
              },
              expression: "dialogVisible1",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }